import React from "react";
import "../../components/bars/PartBar.scss";

const ElabPartBar = ({
  currentPage,
  section_name,
  pagination_color_decision,
  section_number,
  data,
  answers,
  standing_page,
}) => {
  let className = "bg-white/20";
  let textClassName = "text-white/20";

  if (parseInt(`${section_number}`) <= standing_page) {
    className = "bg-white";
    textClassName = "text-white";

  }

  return (
    <>
      <span
        class={`text-sm fw-600 transition-all duration-300 ${textClassName}`}
      >
        {section_name}
      </span>
      <div
        class={`h-1 w-full rounded-full transition-all duration-300 ${className}`}
      ></div>
    </>
  );
};

export default ElabPartBar;
